<template>
  <div
    class="c-layout"
    style="background-image: url(/_resources/app/client/assets/images/savings-calculator-bg.jpg)"
  >
    <transition name="fade">
      <LetsGetStartedView v-show="currentView == 'LetsGetStartedView'" />
    </transition>

    <transition name="fade">
      <div v-show="currentView == 'SliderView'">
        <ProgressBar />
        <tiny-slider
          ref="pageSlider"
          :loop="false"
          items="1"
          gutter="20"
          :controls="false"
          :nav="false"
          :touch="false"
        >
          <PeopleQuestionView />
          <template v-for="category in Categories">
            <template v-for="question in category.Questions">
              <QuestionView
                :key="question.Id"
                :question="question"
                :categoryName="category.Name"
              />
            </template>
          </template>
          <SummaryView />
        </tiny-slider>
      </div>
    </transition>
    <transition name="fade">
      <FinishView v-show="currentView == 'FinishView'" />
    </transition>
    <Footer />
  </div>
</template>
<script>
import { mapFields, mapMultiRowFields } from "vuex-map-fields";
import VueTinySlider from "vue-tiny-slider";
import LetsGetStartedView from "./components/views/LetsGetStartedView.vue";
import PeopleQuestionView from "./components/views/PeopleQuestionView.vue";
import QuestionView from "./components/views/QuestionView.vue";
import SummaryView from "./components/views/SummaryView.vue";
import ProgressBar from "./components/ProgressBar.vue";
import FinishView from "./components/views/FinishView.vue";
import Footer from "./components/Footer.vue";

export default {
  created() {},
  components: {
    "tiny-slider": VueTinySlider,
    LetsGetStartedView,
    PeopleQuestionView,
    QuestionView,
    SummaryView,
    FinishView,
    ProgressBar,
    Footer,
  },
  mounted() {
    console.log("This is init()");
    this.getViewName("LetsGetStartedView");
  },
  watch: {
    //watch for changes from store so we can trigger tinyslider to move
    currentStep: function (val) {
      this.$refs.pageSlider.slider.goTo(val);
    },
    currentView: function (val) {
      this.getViewName(val);
    },
    currentStepName: function (val) {
      this.getViewName(val);
    },
  },
  methods: {
    next() {
      this.$refs.pageSlider.slider.goTo("next");
    },
    prev() {
      this.$refs.pageSlider.slider.goTo("prev");
    },
    getViewName(val) {
      if (val == "SliderView") {
        val = "YOUR HOME"; //sanitize the first slide to Your Home
      }
      val = val.toUpperCase();
      console.log("gtag view value: " + val);

      this.$gtag.event("Navigate", {
        event_category: "Navigation",
        event_label: val,
      });
    },
  },
  computed: {
    ...mapFields([
      "viewContent.Categories",
      "config.currentStep",
      "config.currentView",
      "config.currentStepName",
    ]),
  },
};
</script>
<style lang="scss">
.c-layout {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #f49401;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  @media (max-width: 755px) {
    padding-bottom: 100px;
  }

  h1 {
    font-family: "Nunito";
    font-weight: 800;
    font-size: 32px;
    line-height: 43px;
  }

  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: "Lato";
    font-weight: 600;
  }

  h2 {
    font-size: 25px;
    line-height: 30px;
    margin-bottom: 27px;

    @media (max-width: 755px) {
      font-size: 18px;
      line-height: 22px;
    }
  }

  h4 {
    font-size: 18px;
    line-height: 22px;

    @media (max-width: 755px) {
      font-size: 14px;
      line-height: 19px;
    }
  }

  p {
    font-family: "Lato";
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;

    @media (max-width: 755px) {
      font-size: 16px;
      line-height: 19px;
    }

    a {
      text-decoration: underline;
      color: inherit;
      font-weight: 600;
    }
  }
}

.c-view-container {
  margin: 0 auto;
  max-width: 1020px;
  padding: 0 5%;
  // padding-top: 90px;
  min-height: calc(100vh - 305px);
  // padding-bottom: 165px;

  display: flex;
  align-items: center;
  justify-content: center;
  // padding: 0;
  margin-bottom: 165px;

  @media (max-width: 755px) {
    // padding: 0 5%;
    // padding-top: 30px;
    min-height: calc(100vh - 165px);
    // padding-bottom: 65px;
    margin-bottom: 65px;
  }
}

.c-view-container__inner {
  display: flex;
  flex-direction: row;
  min-width: 755px;
  flex: 0;

  @media (max-width: 755px) {
    min-height: 335px;
    min-width: 100%;
  }
}

.c-view-content-col {
  width: 50%;

  @media (max-width: 755px) {
    width: 70%;
  }
}
.c-view-content-col__inner {
  max-width: 463px;

  @media (max-width: 755px) {
    max-width: none;
    margin-top: 20px;
  }
}
.c-view-animation-col {
  width: 50%;
  max-height: 500px;
  display: flex;
  flex-direction: row-reverse;

  @media (max-width: 755px) {
    width: 30%;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
}

.tns-slider {
  position: relative;
}

.tns-item {
  overflow-x: hidden;
}

.c-view-controls__wrapper {
  bottom: 100px;
  position: absolute;

  @media (max-width: 755px) {
    bottom: 0;
  }
}

.c-view-controls {
  position: relative;
  width: 100vw;
  overflow: hidden;
}

.c-view-controls__inner {
  max-width: 1020px;
  padding: 0 90px;
  margin: 0 auto;
  display: flex;

  &--justify-content {
    justify-content: space-between;
    align-items: flex-end;

    @media (max-width: 755px) {
      flex-direction: column-reverse;
      align-items: flex-start;
    }
  }

  &--end {
    justify-content: flex-end;
  }

  @media (max-width: 755px) {
    padding: 0 5%;
  }
}

.c-buttons__wrapper {
  display: flex;
  flex-wrap: wrap;
}

.c-view_savings-area {
  position: relative;

  @media (max-width: 755px) {
    width: 100%;
    flex-direction: column;
  }
}

.c-view_savings-area {
  &--mobile {
    display: none;

    @media (max-width: 755px) {
      display: flex;
    }
  }
  &--desktop {
    @media (max-width: 755px) {
      display: none;
    }
  }
}

.c-view_savings-area-potential {
  background-color: #08a569;
  margin-bottom: 11px;
  color: #ffffff;
  padding: 4px 9px;
  font-family: "Nunito" !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 19px !important;

  &--bold {
    margin-left: 30px;
    font-weight: 800 !important;
    font-size: 15px !important;
    line-height: 20px !important;

    @media (max-width: 755px) {
      margin-left: 0;
    }
  }
}

.c-view_savings-area-inner {
  display: flex;
  flex-direction: row;

  @media (max-width: 755px) {
    flex-direction: column;
    width: 100%;
  }
}

.c-view_savings-area-top {
  span {
    text-decoration: underline;
  }
}

.c-view_savings-area-bottom {
  text-transform: uppercase;
}

.c-view_savings-area-total {
  background-color: #ffffff;
  min-width: 160px;
  margin-left: 20px;
  align-self: flex-end;

  @media (max-width: 755px) {
    min-width: auto;
    width: 100%;
  }
}

.c-view_savings-area-total-text {
  font-family: "Nunito";
  font-weight: 800;
  font-size: 32px;
  line-height: 43px;
}

.c-question-view_animation-wrapper {
  position: relative;
  max-width: 330px;
  width: 100%;
}

.c-question-view_animation-circle {
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  background-color: #262e6c;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
